import { getLogger } from "@expert/logging";
import { getRootDispatcher } from "@/analytics/rootDispatcher";
import { getSalesApiClient } from "@/sales-tools/home-product/api/api";

type SendNotificationPayload = {
    sessionId: string;
    partner: string;
    productOfferId: string;
    productSku: string;
    customerEmailId?: string;
    customerMdn?: string;
    customerChatId?: string;
    workerSid?: string;
};

export type SendNotificationResponse = {
    maxAttemptsReached: boolean;
    currentAttempt: number;
};

export async function sendNotification(payload: SendNotificationPayload): Promise<SendNotificationResponse> {
    if (!payload.customerEmailId && !payload.customerMdn) {
        throw new Error("Either customerEmailId or customerMdn must be provided");
    }
    const logger = getLogger({ sessionId: payload.sessionId, module: "sendNotification" });
    const dispatcher = getRootDispatcher();
    const client = getSalesApiClient();

    logger.info({ payload }, "Sending notification");

    try {
        const response = await client.post("v1/send-notification", { json: payload });
        if (!response.ok) {
            throw new Error(`Failed to send notification: ${response.status} ${response.statusText}`);
        }
        const data = await response.json<SendNotificationResponse>();
        if (data === null) {
            throw new Error("Received null response from notification service");
        }
        void dispatcher.dispatchBusinessEvent("NotificationSent");
        return data;
    } catch (error) {
        void dispatcher.dispatchBusinessEvent("NotificationSendFailure");
        logger.error({ error }, "Error sending notification");
        throw error;
    }
}
